(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-drip-menu"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setupMenu(root) {
    if (root.dataset.ivMenuReady === 'true') return;
    root.dataset.ivMenuReady = 'true';

    var chips = root.querySelectorAll('[data-iv-filter]');
    var items = root.querySelectorAll('[data-iv-item]');
    var media = root.querySelector('[data-iv-media]');
    var empty = root.querySelector('[data-iv-empty]');
    var keepMedia = root.dataset.showImageFiltered === 'true';

    function countFor(key) {
      if (key === '*') return items.length;
      var n = 0;
      items.forEach(function (item) {
        if ((item.dataset.ivGoals || '').indexOf(',' + key + ',') !== -1) n += 1;
      });
      return n;
    }

    root.querySelectorAll('[data-iv-count]').forEach(function (el) {
      el.textContent = ' (' + countFor(el.dataset.ivCount) + ')';
    });

    function apply(key) {
      var shown = 0;
      items.forEach(function (item) {
        var match = key === '*' || (item.dataset.ivGoals || '').indexOf(',' + key + ',') !== -1;
        item.hidden = !match;
        if (match) shown += 1;
      });

      if (media) media.hidden = !(key === '*' || keepMedia);
      if (empty) empty.hidden = shown !== 0;

      chips.forEach(function (chip) {
        var on = chip.dataset.ivFilter === key;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.dataset.ivFilter);
      });
    });

    apply('*');
  }

  function init() {
    document.querySelectorAll('[data-iv-menu]').forEach(setupMenu);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iv-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    if (root.dataset.ivCarouselReady === 'true') return;
    root.dataset.ivCarouselReady = 'true';

    var track = root.querySelector('[data-iv-track]');
    var slides = root.querySelectorAll('[data-iv-slide]');
    var dots = root.querySelectorAll('[data-iv-dot]');
    var prev = root.querySelector('[data-iv-prev]');
    var next = root.querySelector('[data-iv-next]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var timer = null;
    // Signals that JS owns slide state; until then CSS shows slide 1 only.
    root.classList.add('iv-tst--ready');
    var delay = parseInt(root.dataset.autoplay, 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i) {
      index = (i + slides.length) % slides.length;
      // Slides are stacked in one grid cell, so the height follows whichever
      // slide is active -- no translateX, and no padding from the tallest quote.
      slides.forEach(function (sl, n) {
        var on = n === index;
        sl.classList.toggle('is-active', on);
        sl.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === index);
        d.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
    }

    function start() {
      if (!delay || reduce) return;
      stop();
      timer = window.setInterval(function () { go(index + 1); }, delay);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.ivDot, 10)); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);

    go(0);
    start();
  }

  function init() { document.querySelectorAll('[data-iv-carousel]').forEach(setup); }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();

  } catch(e) { console.error(e); }
})();
})();
